import { createFileRoute, redirect } from "@tanstack/react-router"
import { canManageBulkUpdates } from "@/features/change-projects/core/access"

export const Route = createFileRoute("/(authenticated)/bulk-updates/$changeProjectId/")({
  beforeLoad: ({ context, params }) => {
    throw redirect({
      to: canManageBulkUpdates(context.user)
        ? "/bulk-updates/$changeProjectId/select"
        : "/bulk-updates/$changeProjectId/review",
      params: { changeProjectId: params.changeProjectId },
    })
  },
})
